import { Routes } from '@angular/router';

import { ProfilePageComponent } from './profile-page.component';

/**
 * Rutas de `/perfil` (B26 de B10). El contenedor pinta las pestañas y el `<router-outlet>`; cada hija es una
 * pestaña. `pedidos` y `pedidos/:id` son «Mis pedidos» (W1), `deseos` la lista de deseos (W2) y `ajustes`, los ajustes
 * de la cuenta (W3). Con W2 ya no queda ninguna en el marcador «Muy pronto» de W0a, que se retira. `coins` es
 * «Mis Coins» (A0·web de Perrón Coins).
 *
 * `comunidad` es el contrato con B11 (§5.5): la línea va verbatim y lo de dentro de `tab-community/` es suyo.
 * Todo `/perfil` es `RenderMode.Client` (`app.routes.server.ts`).
 */
export const PROFILE_ROUTES: Routes = [
  {
    path: '',
    component: ProfilePageComponent,
    children: [
      { path: '', redirectTo: 'pedidos', pathMatch: 'full' },
      {
        path: 'pedidos',
        loadComponent: () =>
          import('./components/profile-orders/profile-orders.component').then((m) => m.ProfileOrdersComponent),
      },
      {
        path: 'pedidos/:id',
        loadComponent: () =>
          import('./components/profile-order-detail/profile-order-detail.component').then(
            (m) => m.ProfileOrderDetailComponent,
          ),
      },
      {
        path: 'coins',
        loadComponent: () =>
          import('./components/profile-coins/profile-coins.component').then((m) => m.ProfileCoinsComponent),
      },
      {
        path: 'deseos',
        loadComponent: () =>
          import('./components/profile-wishlist/profile-wishlist.component').then((m) => m.ProfileWishlistComponent),
      },
      {
        path: 'ajustes',
        loadComponent: () =>
          import('./components/profile-settings/profile-settings.component').then((m) => m.ProfileSettingsComponent),
      },
      { path: 'comunidad', loadComponent: () => import('./components/tab-community/tab-community.component').then(m => m.TabCommunityComponent) },
    ],
  },
];
